import ENFlag from "@/components/SelectLanguage/ENFlag";
import FRFlag from "@/components/SelectLanguage/FRFlag";
import NLFlag from "@/components/SelectLanguage/NLFlag";
import { IconComponent } from "@enxcs/dap-ui-stratos";

export enum LanguagesCode {
  ENGLISH = "en",
  DUTCH = "nl",
  FRENCH = "fr",
}
interface Language {
  name: string;
  initials: LanguagesCode;
  icon: IconComponent | undefined;
}

type LanguagesMap = {
  [key: string]: Language;
};

export const LANGUAGES: LanguagesMap = {
  en: {
    name: "English",
    initials: LanguagesCode.ENGLISH,
    icon: ENFlag,
  },
  nl: {
    name: "Dutch",
    initials: LanguagesCode.DUTCH,
    icon: NLFlag,
  },
  fr: {
    name: "French",
    initials: LanguagesCode.FRENCH,
    icon: FRFlag,
  },
};

export const FALLBACK_LANG = LanguagesCode.ENGLISH;

export const supportedLanguages = Object.values(LanguagesCode);
